module.exports = __webpack_public_path__ + "static/img/22.5fa6bc2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/eng/22.png
// module id = GkR3
// module chunks = 0